<template>
  <modal :modal-key="'confirm_purchase_for_pin'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
      <img class="usericon" src="static/images/happy_face_2.svg" alt="">
    </template>
    <template slot="body">
      <p class="modal_strong" v-if="!getBundleData.joker">
        {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' +
        getTranslations.home_modals_confirm_purchase_pin_games:'' }}
        {{ getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_pin_and :''
        }}
        {{ getBundleData.points?getBundleData.points + ' ' +
        getTranslations.home_modals_confirm_purchase_pin_points:''}}
        – {{ getBundleData.price
        }} {{ getBundleData.currencyCode }}</p>
      <p class="modal_strong"  v-else>
        {{ getBundleData.numOfJokers }}  {{ getTranslations.home_modals_confirm_purchase_jokers }} – {{ getBundleData.price
        }} {{ getBundleData.currencyCode }}</p>
      <p v-if="getBundleData.joker"> {{ getTranslations.home_modals_confirm_purchase_jokers_increase }}</p>
      <p>{{ getTranslations.home_modals_confirm_purchase_pin_we_have_sent }}</p>
      <form action="">
        <div :class="[ errorMessage ? 'form-group has-warning' : '' ]">
          <input type="text" @keyup="check()" class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_confirm_purchase_pin_enter_the_4" v-model="pin"/>
          <span v-show="errorMessage" class="form-group__feedback">{{ message }}</span>
        </div>
        <input type="submit" :value="getTranslations.home_modals_confirm_purchase_pin_confirm_button"
               :class="['btn2 btn2--std btn2--small btn2--fixed', (errorMessage || !buttonEnabled)? 'deactivated' : '']"
               @click.prevent="purchaseBundle()">
      </form>
    </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import ConfirmPurchaseForPinError from './ConfirmPurchaseForPinError';
import FailedPurchase from './FailedPurchase';


export default {
  name: 'confirm-purchase-for-pin',
  components: {
    Modal,
  },
  data() {
    return {
      errorMessage: false,
      message: '',
      pin: '',
      showedModal: false,
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        this.message = '';
      }
    },
    purchaseBundle() {
      if (!this.errorMessage && (this.pin.length >= 4 && this.pin.length <= 8)) {
        this.buttonEnabled = false;
        this.getUserLoginDetails().then(() => {
          const bundleInfo = {
            bundleId: this.bundleId,
            pin: this.pin,
          };
          this.chargePinCall({ value: bundleInfo }).then(() => {
            this.buttonEnabled = true;
            if (this.chargePinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseSuccessful);
              this.$emit('bundlePurchase');
            } else if (this.chargePinResponse === 'WRONG_PIN') {
              this.errorMessage = true;
              this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
            } else if (this.chargePinResponse === 'NO_BALANCE') {
              this.storeModalForStore(FailedPurchase);
              this.errorMessage = true;
              this.message = this.getTranslations.home_modals_confirm_purchase_pin_no_balance;
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
            }
          });
        });
      } else {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseForPin.vue